/* eslint-disable no-underscore-dangle */
import React, { useCallback } from 'react';

import { AdvancedMarker } from '@vis.gl/react-google-maps';
import getCategoryIcon from '../../media/categoriesMap';

import LocationIcon from '../../media/categories/location_icon.svg';

const ReportMarker = ({ report, map, onSelectReport, selectedReportId, setMarkers }) => {
  const position = {
    lat: Number(report.location?.latitude),
    lng: Number(report.location?.longitude),
  };

  const panToReportLocation = useCallback(() => {
    if (!map) return;
    const referenceZoom = map.getZoom();
    const referenceOffset = 0.005;
    if (referenceZoom < 15) map.setZoom(15);
    const dynamicOffset = referenceOffset * 2 ** (15 - referenceZoom);
    setTimeout(
      () =>
        map.setCenter({
          lat: report.location.latitude,
          lng: report.location.longitude - dynamicOffset,
        }),
      100
    );
    onSelectReport(report?._id);
  }, [map, report.location]);

  const handleRef = useCallback(
    (node) => {
      setMarkers((prevMap) => {
        if (prevMap.get(report._id) === node) return prevMap; // No change, skip update
        const newMap = new Map(prevMap);
        if (node) newMap.set(report._id, node);
        else newMap.delete(report._id);
        return newMap;
      });
    },
    [report._id]
  );

  return (
    <AdvancedMarker
      position={position}
      onClick={panToReportLocation}
      zIndex={selectedReportId === report._id ? 200 : 50}
      ref={handleRef}
    >
      <img
        className="z-20 bg-white w-[36px] h-[36px] top-[25px] left-[6px] relative rounded-full"
        src={getCategoryIcon(report.type)}
        alt=""
      />
      <img className="relative bottom-[15px]" src={LocationIcon} alt="" />
    </AdvancedMarker>
  );
};

export default ReportMarker;
